import { render } from "./trainingModuleTable.vue?vue&type=template&id=3c73da9d&scoped=true&ts=true"
import script from "./trainingModuleTable.vue?vue&type=script&lang=ts"
export * from "./trainingModuleTable.vue?vue&type=script&lang=ts"

import "./trainingModuleTable.vue?vue&type=style&index=0&id=3c73da9d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c73da9d"]])

export default __exports__